export function containSameElements(arr1: any[], arr2: any[]) {
    if (arr1.length !== arr2.length) return false
    const set1 = new Set(arr1)
    const set2 = new Set(arr2)
    const set3 = new Set([...arr1, ...arr2])
    return set1.size === set3.size && set2.size === set3.size
  }